import SpamUsersList from './SpamUsersList';

export default SpamUsersList;
